import { m } from "motion/react";
import { twJoin } from "tailwind-merge";

type Step = {
  id: string;
};

type StepSidebarProps<T extends Step> = {
  ariaLabel: string;
  steps: T[];
  currentStepId: string;
  children: (step: T, index: number) => React.ReactNode;
};

export const StepSidebar = <T extends Step>({
  ariaLabel,
  steps,
  currentStepId,
  children,
}: StepSidebarProps<T>) => {
  return (
    <nav
      aria-label={ariaLabel}
      className="sticky top-0 w-full self-start rounded-lg border border-gray-200 bg-white px-3 py-4"
    >
      <ol className={twJoin("relative isolate flex flex-col gap-y-3")}>
        <m.div
          animate={{
            y: steps.findIndex((step) => step.id === currentStepId) * 36,
          }}
          className="absolute z-0 rounded-lg bg-gray-100"
          initial={false}
          style={{
            height: "24px",
            width: "100%",
            left: "0px",
            top: "0px",
          }}
          transition={{
            type: "spring",
            stiffness: 300,
            damping: 30,
          }}
        />
        {steps.map((step, index) => (
          <li key={step.id} className="relative" data-loc={`step-${step.id}`}>
            {children(step, index)}
          </li>
        ))}
      </ol>
    </nav>
  );
};
